export default __webpack_public_path__ + "static/media/create_new_password_cover.b832ec28.svg";